export default __webpack_public_path__ + "static/media/tree_4_anim.737fa7fb.gif";